import React, { useEffect } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, Row, Tooltip } from "antd"
import { isMobile } from "react-device-detect"
import PricingModal from "components/pages/guest/pricing/PricingModal"
import FullPageContentLoader from "components/common/FullPageContentLoader"

import usePricingModal from "hooks/pricing/use-pricing-modal"
import useIndex from "hooks/pricing/use-index"

const courseColSpans = {
  xs: { span: 24 },
  sm: { span: 8 },
  md: { span: 6 },
}

const BuyCourseButton = ({ course }) => {
  const { setPricingModalVisible, setPricingModalCourse } = usePricingModal()

  const handleOpenModal = () => {
    setPricingModalCourse(course)
    setPricingModalVisible(true)
  }

  return (
    <Button
      type="primary"
      size="large"
      block
      onClick={handleOpenModal}
      style={{
        margin: "10px 0",
        whiteSpace: "normal",
        height: "auto",
        minHeight: "50px",
      }}
    >
      Buy Course
    </Button>
  )
}

const CourseCard = ({ course }) => {
  return (
    <Col {...courseColSpans} className="m-t-20">
      <div className="course-item-card">
        <div className="course-image">
          <img src={course.image_url} alt={course.name}></img>
        </div>
        <div className="course-info">
          <Tooltip placement="top" title={course.name} arrowPointAtCenter>
            <div className="course-title">{course.name}</div>
          </Tooltip>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <BuyCourseButton course={course} />
          </div>
        </div>
      </div>
    </Col>
  )
}

const CourseCards = ({ courses }) => {
  return (
    <div className="course-list">
      <Row gutter={20} type="flex">
        {courses.map((course) => (
          <CourseCard key={course.id} course={course} />
        ))}
      </Row>
    </div>
  )
}

const PricingPage = () => {
  const { isLoading, courses } = useIndex()
  const {
    pricingModalVisible,
    setPricingModalCourse,
    setPricingModalVisible,
  } = usePricingModal()
  const { id } = useParams()

  useEffect(() => {
    if (!id) return
    if (isLoading) return

    const currentCourse = courses.find((c) => c.id.toString() === id)
    if (!currentCourse) return

    setPricingModalCourse(currentCourse)
    setPricingModalVisible(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, isLoading, courses])

  if (isLoading) return <FullPageContentLoader />

  return (
    <div className={`page course-page ${isMobile ? "mobile" : ""}`}>
      {pricingModalVisible && <PricingModal />}
      <div className="auth-form-logo">
        <img src="/logo-inline-colored.png" alt="Learner's logo" />
      </div>

      <h1 style={{ textAlign: "center", margin: "2rem 0" }}>Courses Pricing</h1>
      <div className="pricing-page">
        <CourseCards courses={courses} />
      </div>
    </div>
  )
}

export default PricingPage
